<template>
    <div>
        <van-nav-bar title="商城"/>
        <Cls1Tab :parent="query.cls" @pick="pickCls1"/>
        <van-cell :title="vipinfo.car_code" @click="carshow=true" is-link />
        <van-list v-model="loading">
            <div v-for="item in data" :key="item.id" @click="goDetail(item)" class="item">
                <van-image :src="item.product_imageurl" rel="external nofollow"  />
                <van-row type="flex" justify="space-between" class="footer">
                    <van-col span="16" class="left">{{ item.product_name }}</van-col>
                    <van-col span="8" class="right">¥{{ item.advise_price }}</van-col>
                </van-row>
            </div>
        </van-list>
        <van-popup
            v-model="carshow"
            closeable
            position="bottom"
            :style="{ height: '50%' }">
            <van-address-list
                id='cars'
                v-model="vipinfo.car"
                :list="vipinfo.cars"
                default-tag-text="Default"
                add-button-text='增加爱车'
                @select="selCar"
                @add="addCar"/>
        </van-popup>
        <AddCar ref="addcar"/>
    </div>
</template>

<script>
import { 
    NavBar, 
    Cell,
    Card, 
    Grid,
    GridItem,
    Image,
    Row,
    Col,
    Icon, 
    Popup,
    Loading, 
    DropdownMenu,
    DropdownItem,
    Tab,
    Tabs,
    List,
    AddressList
} from 'vant'

import { DirectSellApi } from '@/api/directsell'
import { VipApi } from '@/api/market'
import AddCar from '@/view/user/components/addcar'
import Cls1Tab from '@/view/components/cls1tab'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Card.name]: Card,
        [Cell.name]: Cell,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [Popup.name]: Popup,
        [AddressList.name]: AddressList,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        AddCar,
        Cls1Tab
    },
    data() {
        return {
            data: [],
            loading: false,
            finished: false,
            total: 0,
            carshow: false,
            vipinfo: {
                shop: null,
                user: null,
                shop_name: null,
                user_name: null,
                grade: null,
                grade_name: null,
                phone: null,
                car_code: '',
                car: null,
                cars: [],
                available_score: null,
                total_consumption: null,
                vip_address: null,
                vip_email: null,
                sex: null,
                avatar: null
            },
            query: {
                cls: 53, // 改装升级
                cls1: 0, // 所有
                prd_name: null,
                carmodel: null,
                purpose: null,
                sort: 1,
                page: 1,
                page_size: 10
            },
            name: '分类商品'
        }
    },
    mounted() {
        this.getVipInfo()
        this.getData()
    },
    methods: {
        getVipInfo() {
            var that = this
            that.axios.get(VipApi).then((ret) => {
                if (ret.flag) {
                    that.vipinfo = ret.details
                    const cars = []
                    that.vipinfo.cars.forEach((it) => {
                        cars.push({
                            id: it.id,
                            tel: '',
                            name: it.code,
                            address: it.name
                        })
                    })
                    // cars.push({
                    //     id: 1,
                    //     tel: '232',
                    //     name: '所有',
                    //     address: 'che'
                    // })
                    that.vipinfo.cars = cars
                }
            })
        },
        getData() {
            var that = this
            that.loading = true
            this.axios.get(DirectSellApi, { params: this.query}).then((ret) => {
                that.loading = false
                // that.total = ret.count
                if (ret.results == null || ret.results.length ===0 ) {
                    that.finished = true
                    return
                }
                that.data = ret.results
                if (that.data.length >= that.total) {
                    that.finished = true
                }
            })
        },
        onLoad() {
            this.query.page = this.query.page + 1
            this.getData()
        },
        goDetail(item) {
            this.$router.push(`/nt/directsell/${item.id}`)
        },
        selCar(item) {
            this.vipinfo.car = item.id
            this.vipinfo.car_code = item.name
            this.carshow = false
        },
        addCar() {
            this.carshow = false
            this.$refs.addcar.add()
        },
        editCar(itm, index) {
            console.log(index)
            this.$refs.addcar.edit(itm.id)
        },
        pickCls1(data) {
            this.query.cls1 = data.id
            this.getData()
        }
    }
}
</script>

<style>
.van-address-item__edit {
    display: none;
}
</style>

<style>
.van-address-item__edit {
    display: none;
}
</style>

<style lang="less" scoped>
    .item {
        margin-bottom: 10px;
        .footer {
            padding-left: 10px;
            padding-right: 10px;

            .left {
                max-width: 100%; /*最大宽度为当前元素的100%*/
                display: inline-block;
                white-space: nowrap;/*保证文本内容不会自动换行，如果多余的内容会在水平方向撑破单元格*/ 
                overflow: hidden; /*隐藏超出单元格的部分*/
            }
            .right {
                text-align: right;
                color: red;
            }
        }
    }
</style>